"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareNaturalDependencies = void 0;

var _dependenciesCompareGenerated = require("./dependenciesCompare.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var compareNaturalDependencies = {
  compareDependencies: _dependenciesCompareGenerated.compareDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createCompareNatural: _factoriesAny.createCompareNatural
};
exports.compareNaturalDependencies = compareNaturalDependencies;